import { render, staticRenderFns } from "./DataTableResponsive.vue?vue&type=template&id=415c4de7"
import script from "./DataTableResponsive.vue?vue&type=script&lang=ts"
export * from "./DataTableResponsive.vue?vue&type=script&lang=ts"
import style0 from "./DataTableResponsive.vue?vue&type=style&index=0&id=415c4de7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports